/* =========================================================================
   Nutritia theme — vanilla JS, no dependencies.
   ========================================================================= */
(function () {
  'use strict';

  var cfg = window.Nutritia || {};
  var routes = cfg.routes || {};

  /* ---------------------------------------------------------- utilities */

  function money(cents) {
    var fmt = cfg.moneyFormat || '${{amount}}';
    var value = (cents / 100).toFixed(2);
    var parts = value.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var withCommas = parts.join('.');
    return fmt
      .replace(/\{\{\s*amount\s*\}\}/g, withCommas)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, parts[0])
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, value.replace('.', ','))
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, parts[0]);
  }

  function on(root, evt, selector, handler) {
    root.addEventListener(evt, function (e) {
      var el = e.target.closest(selector);
      if (el && root.contains(el)) handler(e, el);
    });
  }

  /* ------------------------------------------------------------- drawers */

  var lastFocus = null;

  function openDrawer(id) {
    var d = document.getElementById(id);
    if (!d) return;
    closeAllDrawers();
    lastFocus = document.activeElement;
    d.classList.add('is-open');
    d.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
    document.querySelectorAll('[data-drawer-open="' + id + '"]').forEach(function (el) { el.setAttribute('aria-expanded', 'true'); });
    var focusable = d.querySelector('.drawer__panel button, .drawer__panel a, .drawer__panel input, .drawer__panel select');
    if (focusable) focusable.focus();
  }

  function closeDrawer(d) {
    if (typeof d === 'string') d = document.getElementById(d);
    if (!d) return;
    d.classList.remove('is-open');
    d.setAttribute('aria-hidden', 'true');
    document.querySelectorAll('[data-drawer-open="' + d.id + '"]').forEach(function (el) { el.setAttribute('aria-expanded', 'false'); });
    document.documentElement.style.overflow = '';
    if (lastFocus) lastFocus.focus();
  }

  function closeAllDrawers() {
    document.querySelectorAll('.drawer.is-open').forEach(closeDrawer);
  }

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-drawer-open]');
    if (opener) {
      e.preventDefault();
      openDrawer(opener.getAttribute('data-drawer-open'));
      return;
    }
    var closer = e.target.closest('[data-drawer-close]');
    if (closer) {
      e.preventDefault();
      closeDrawer(closer.closest('.drawer'));
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeAllDrawers();
    if (e.key !== 'Tab') return;
    var panel = document.querySelector('.drawer.is-open .drawer__panel');
    if (!panel) return;
    var stops = Array.prototype.filter.call(panel.querySelectorAll('a[href], button, input, select, textarea, [tabindex]'), function (el) {
      return !el.disabled && el.tabIndex >= 0 && el.getClientRects().length > 0;
    });
    if (!stops.length) return;
    var first = stops[0], last = stops[stops.length - 1];
    if (!panel.contains(document.activeElement) || (e.shiftKey && document.activeElement === first) || (!e.shiftKey && document.activeElement === last)) {
      e.preventDefault();
      (e.shiftKey ? last : first).focus();
    }
  });

  /* ---------------------------------------------------------------- cart */

  function refreshCart() {
    return fetch(routes.cart_url + '?section_id=cart-drawer-content', {
      headers: {'X-Requested-With': 'XMLHttpRequest'}
    })
      .then(function (r) {
        return r.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-cart-content]');
        var target = document.querySelector('[data-cart-content]');
        if (fresh && target) target.innerHTML = fresh.innerHTML;
        return fetch(routes.cart_url + '.js').then(function (r) {
          return r.json();
        });
      })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
          el.hidden = cart.item_count === 0;
        });
        return cart;
      });
  }

  // Inline add-to-cart error, announced to screen readers, instead of a
  // blocking browser alert. Cleared on the next attempt.
  function showAtcError(form, message) {
    if (!form.parentNode) return;
    var msg = form.parentNode.querySelector('[data-atc-error]');
    if (!msg) {
      msg = document.createElement('p');
      msg.className = 'atc-error';
      msg.setAttribute('role', 'alert');
      msg.setAttribute('data-atc-error', '');
      form.parentNode.insertBefore(msg, form.nextSibling);
    }
    msg.textContent = message;
    msg.hidden = false;
  }

  // Add to cart
  on(document, 'submit', 'form[data-atc-form]', function (e, form) {
    e.preventDefault();
    if (form.dataset.submitting === 'true') return;
    form.dataset.submitting = 'true';
    var staleError = form.parentNode && form.parentNode.querySelector('[data-atc-error]');
    if (staleError) staleError.hidden = true;
    // The pressed button: "Buy now" ([data-buy-now]) goes to checkout after
    // the add instead of opening the drawer.
    var pressed = e.submitter && form.contains(e.submitter) ? e.submitter : null;
    var buyNow = !!(pressed && pressed.hasAttribute('data-buy-now'));
    var btn = pressed || form.querySelector('[type="submit"]');
    var original = btn ? btn.innerHTML : '';
    if (btn) {
      btn.setAttribute('aria-disabled', 'true');
      btn.textContent = buyNow ? window.Nutritia.t('to_checkout', 'To checkout…') : window.Nutritia.t('adding', 'Adding…');
    }

    fetch(routes.cart_add_url, {
      method: 'POST',
      headers: {Accept: 'application/javascript'},
      body: new FormData(form)
    })
      .then(function (r) {
        return r.json();
      })
      .then(function (res) {
        if (res.status) throw new Error(res.description || res.message);
        if (buyNow) {
          window.location.href = '/checkout';
          return null;
        }
        return refreshCart();
      })
      .then(function () {
        if (!buyNow && cfg.cartDrawer) openDrawer('cart-drawer');
      })
      .catch(function (err) {
        console.error('[Nutritia] add to cart failed', err);
        showAtcError(form, err.message || window.Nutritia.t('add_error', 'We couldn\u2019t add that to your bag. Please try again.'));
      })
      .finally(function () {
        delete form.dataset.submitting;
        if (btn) {
          btn.removeAttribute('aria-disabled');
          btn.innerHTML = original;
        }
      });
  });

  function changeLine(key, quantity) {
    return fetch(routes.cart_change_url, {
      method: 'POST',
      headers: {'Content-Type': 'application/json', Accept: 'application/json'},
      body: JSON.stringify({id: key, quantity: quantity})
    })
      .then(function (r) {
        return r.json();
      })
      .then(function (res) {
        if (res.status) throw new Error(res.description || window.Nutritia.t('update_error', 'Could not update your bag. Please try again.'));
        if (document.querySelector('[data-cart-page]')) { window.location.reload(); return; }
        return refreshCart();
      })
      .catch(function (err) { alert(err.message || window.Nutritia.t('update_error', 'Could not update your bag. Please try again.')); });
  }

  on(document, 'click', '[data-line-change]', function (e, el) {
    e.preventDefault();
    changeLine(el.getAttribute('data-line-key'), el.getAttribute('data-line-change'));
  });

  // PDP gallery on phones: thumbnails scroll the swipeable track, and the
  // active thumbnail follows swipes. Desktop shows the mosaic, so the
  // thumbnails are hidden there and this does nothing visible.
  document.querySelectorAll('[data-pdp-media]').forEach(function (media) {
    var track = media.querySelector('[data-pdp-track]');
    var thumbs = Array.prototype.slice.call(media.querySelectorAll('[data-pdp-thumb]'));
    if (!track || !thumbs.length) return;
    function mark(id) {
      thumbs.forEach(function (t) {
        var on = t.getAttribute('data-pdp-thumb') === id;
        t.classList.toggle('is-active', on);
        if (on) t.setAttribute('aria-current', 'true'); else t.removeAttribute('aria-current');
      });
    }
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        var target = document.getElementById(t.getAttribute('data-pdp-thumb'));
        if (!target) return;
        track.scrollTo({left: target.offsetLeft - track.offsetLeft, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
        mark(t.getAttribute('data-pdp-thumb'));
      });
    });
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { if (e.isIntersecting && e.intersectionRatio > 0.6) mark(e.target.id); });
      }, {root: track, threshold: [0.6]});
      track.querySelectorAll('.pdp-tile').forEach(function (tile) { io.observe(tile); });
    }
  });

  // Opening offer: add both products in one request, then show the drawer so
  // the automatically applied discount is visible straight away.
  on(document, 'click', '[data-bundle-add]', function (e, btn) {
    if (btn.getAttribute('aria-disabled') === 'true') return;
    var ids = btn.getAttribute('data-bundle-add').split(',');
    var original = btn.textContent;
    btn.setAttribute('aria-disabled', 'true');
    btn.textContent = window.Nutritia.t('adding', 'Adding…');
    fetch(routes.cart_add_url + '.js', {
      method: 'POST',
      headers: {'Content-Type': 'application/json', Accept: 'application/json'},
      body: JSON.stringify({items: ids.map(function (id) { return {id: Number(id), quantity: 1}; })})
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status) throw new Error(res.description || res.message);
        return refreshCart();
      })
      .then(function () { if (cfg.cartDrawer) openDrawer('cart-drawer'); })
      .catch(function (err) {
        console.error('[Nutritia] bundle add failed', err);
        alert(err.message || window.Nutritia.t('bundle_error', 'Could not add the bundle.'));
      })
      .finally(function () {
        btn.removeAttribute('aria-disabled');
        btn.textContent = original;
      });
  });

  // Convert a one-time line into a subscription in place. /cart/change.js
  // accepts selling_plan, so the line keeps its quantity and the drawer
  // re-renders with the plan name and new price.
  on(document, 'click', '[data-line-subscribe]', function (e, el) {
    el.setAttribute('aria-disabled', 'true');
    el.textContent = window.Nutritia.t('switching', 'Switching…');
    fetch(routes.cart_change_url + '.js', {
      method: 'POST',
      headers: {'Content-Type': 'application/json', Accept: 'application/json'},
      body: JSON.stringify({
        id: el.getAttribute('data-line-subscribe'),
        quantity: Number(el.getAttribute('data-quantity') || 1),
        selling_plan: Number(el.getAttribute('data-plan'))
      })
    })
      .then(function (r) {
        if (!r.ok) throw new Error(window.Nutritia.t('switch_error', 'Could not switch to a subscription.'));
        return refreshCart();
      })
      .catch(function (err) {
        console.error('[Nutritia] subscribe switch failed', err);
        el.removeAttribute('aria-disabled');
        el.textContent = window.Nutritia.t('switch_sub', 'Switch to subscription');
      });
  });

  on(document, 'click', '[data-line-remove]', function (e, el) {
    e.preventDefault();
    changeLine(el.getAttribute('data-line-remove'), 0);
  });

  /* ------------------------------------------------------------- stepper */

  on(document, 'click', '[data-qty]', function (e, btn) {
    e.preventDefault();
    var wrap = btn.closest('.stepper');
    var input = wrap.querySelector('input');
    var min = parseInt(input.min || '1', 10);
    var max = parseInt(input.max || '99', 10);
    var next = parseInt(input.value || '1', 10) + parseInt(btn.getAttribute('data-qty'), 10);
    next = Math.min(max, Math.max(min, next));
    input.value = next;
    input.dispatchEvent(new Event('change', {bubbles: true}));

    // Cart-line steppers post the change.
    var key = wrap.getAttribute('data-line-key');
    if (key) changeLine(key, next);
  });

  /* -------------------------------------------------------- announcement */

  document.querySelectorAll('[data-announcement]').forEach(function (bar) {
    var msgs = bar.querySelectorAll('.announcement__msg');
    var dots = bar.querySelectorAll('.announcement__dot');
    if (msgs.length < 2) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var i = 0;
    var delay = parseInt(bar.getAttribute('data-interval'), 10) || 5000;

    function show(n) {
      msgs.forEach(function (m, idx) {
        m.classList.toggle('is-active', idx === n);
      });
      dots.forEach(function (d, idx) {
        d.classList.toggle('is-active', idx === n);
      });
      i = n;
    }

    dots.forEach(function (d, idx) {
      d.addEventListener('click', function () {
        show(idx);
      });
    });

    setInterval(function () {
      show((i + 1) % msgs.length);
    }, delay);
  });

  /* ------------------------------------------------------------- gallery */

  document.querySelectorAll('[data-gallery]').forEach(function (gal) {
    var main = gal.querySelector('[data-gallery-main]');
    on(gal, 'click', '[data-gallery-thumb]', function (e, thumb) {
      e.preventDefault();
      var src = thumb.getAttribute('data-src');
      var srcset = thumb.getAttribute('data-srcset');
      if (main && src) {
        main.src = src;
        if (srcset) main.srcset = srcset;
        main.alt = thumb.getAttribute('data-alt') || '';
      }
      gal.querySelectorAll('[data-gallery-thumb]').forEach(function (t) {
        t.classList.toggle('is-active', t === thumb);
      });
    });
  });

  /* ------------------------------------------------------ variant picker */

  document.querySelectorAll('[data-variant-picker]').forEach(function (picker) {
    var dataEl = document.querySelector('[data-variant-json="' + picker.getAttribute('data-product') + '"]');
    if (!dataEl) return;

    var variants;
    try {
      variants = JSON.parse(dataEl.textContent);
    } catch (err) {
      return;
    }

    var form = document.querySelector('form[data-atc-form][data-product="' + picker.getAttribute('data-product') + '"]');
    var idInput = form ? form.querySelector('[name="id"]') : null;

    function selected() {
      var out = {};
      picker.querySelectorAll('[data-option-name].is-active').forEach(function (el) {
        out[el.getAttribute('data-option-name')] = el.getAttribute('data-option-value');
      });
      return out;
    }

    function apply() {
      var sel = selected();
      var match = variants.find(function (v) {
        return v.options.every(function (o) {
          return sel[o.name] === undefined || sel[o.name] === o.value;
        });
      });
      if (!match) return;

      if (idInput) idInput.value = match.id;

      var priceEl = picker.querySelector('[data-variant-price]');
      if (priceEl) priceEl.textContent = money(match.price);

      var wasEl = picker.querySelector('[data-variant-compare]');
      if (wasEl) {
        if (match.compare_at_price && match.compare_at_price > match.price) {
          wasEl.textContent = money(match.compare_at_price);
          wasEl.hidden = false;
        } else {
          wasEl.hidden = true;
        }
      }

      // One-time plan row mirrors the variant price.
      var oneTime = document.querySelector('[data-plan-price="onetime"]');
      if (oneTime) oneTime.textContent = money(match.price);

      var btn = form ? form.querySelector('[type="submit"]') : null;
      if (btn) {
        btn.disabled = !match.available;
        btn.textContent = match.available ? window.Nutritia.t('add_to_cart', 'Add to cart') : window.Nutritia.t('sold_out', 'Sold out');
      }

      if (match.featured_image) {
        var main = document.querySelector('[data-gallery-main]');
        if (main) main.src = match.featured_image;
      }

      if (history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', match.id);
        history.replaceState({}, '', url);
      }
    }

    on(picker, 'click', '[data-option-name]', function (e, el) {
      e.preventDefault();
      var name = el.getAttribute('data-option-name');
      picker.querySelectorAll('[data-option-name="' + name + '"]').forEach(function (sib) {
        sib.classList.toggle('is-active', sib === el);
      });
      var label = picker.querySelector('[data-option-label="' + name + '"]');
      if (label) label.textContent = el.getAttribute('data-option-value');
      apply();
    });
  });

  /* ---------------------------------------------------- purchase options */

  document.querySelectorAll('[data-plans]').forEach(function (group) {
    on(group, 'change', 'input[type="radio"]', function (e, input) {
      group.querySelectorAll('.plan').forEach(function (p) {
        p.classList.toggle('is-active', p.contains(input));
      });
      var box = group.closest('[data-buy-box]');
      var form = (box && box.querySelector('form[data-atc-form]')) || document.querySelector('form[data-atc-form]');
      if (!form) return;
      var field = form.querySelector('[name="selling_plan"]');
      if (!field) {
        field = document.createElement('input');
        field.type = 'hidden';
        field.name = 'selling_plan';
        form.appendChild(field);
      }
      field.value = input.value || '';
      if (!input.value) field.remove();

      // Keep the price in the button in step with the chosen option, so the
      // subscription saving is visible at the exact moment of clicking.
      if (input.getAttribute('data-price')) {
        document.querySelectorAll('[data-atc-price]').forEach(function (el) {
          el.textContent = input.getAttribute('data-price');
        });
      }
      // The sticky bar names the chosen option, so its button never adds
      // something other than what the shopper thinks it will.
      if (input.getAttribute('data-plan-label')) {
        document.querySelectorAll('[data-atc-plan]').forEach(function (el) {
          el.textContent = input.getAttribute('data-plan-label');
        });
      }
    });
  });

  /* ---------------------------------------------------------- sticky ATC */

  var sticky = document.querySelector('.sticky-atc');
  var buyBox = document.querySelector('[data-buy-box]');
  if (sticky && buyBox && 'IntersectionObserver' in window) {
    new IntersectionObserver(
      function (entries) {
        sticky.classList.toggle('is-visible', !entries[0].isIntersecting);
      },
      {rootMargin: '0px 0px -80% 0px'}
    ).observe(buyBox);
  }

  /* ------------------------------------------------------------- filters */

  var grid = document.querySelector('[data-filter-grid]');
  if (grid) {
    var selects = document.querySelectorAll('[data-filter]');
    var countEl = document.querySelector('[data-filter-count]');
    var originalItems = Array.prototype.slice.call(grid.querySelectorAll('[data-price][data-title]'));
    var emptyEl = document.querySelector('[data-filter-empty]');

    function applyFilters() {
      var flavor = document.querySelector('[data-filter="flavor"]');
      var goal = document.querySelector('[data-filter="goal"]');
      var sort = document.querySelector('[data-filter="sort"]');
      var fv = flavor ? flavor.value : 'All';
      var gv = goal ? goal.value : 'All';
      var sv = sort ? sort.value : 'featured';

      var items = originalItems.slice();
      var shown = 0;

      items.forEach(function (item) {
        var flavors = (item.getAttribute('data-flavors') || '').split('|');
        var goals = (item.getAttribute('data-goals') || '').split('|');
        var ok =
          (fv === 'All' || flavors.indexOf(fv) !== -1) &&
          (gv === 'All' || goals.indexOf(gv) !== -1);
        item.hidden = !ok;
        if (ok) shown++;
      });

      var visible = items.filter(function (i) {
        return !i.hidden;
      });
      if (sv !== 'featured') {
        visible.sort(function (a, b) {
          var pa = parseInt(a.getAttribute('data-price'), 10);
          var pb = parseInt(b.getAttribute('data-price'), 10);
          if (sv === 'price-asc') return pa - pb;
          if (sv === 'price-desc') return pb - pa;
          return (a.getAttribute('data-title') || '').localeCompare(
            b.getAttribute('data-title') || ''
          );
        });
      }
      visible.forEach(function (el) { grid.appendChild(el); });
      if (emptyEl) emptyEl.hidden = shown !== 0 || originalItems.length === 0;

      if (countEl) {
        countEl.textContent = shown === 1 ? window.Nutritia.t('product_one', '{n} product', {n: shown}) : window.Nutritia.t('product_other', '{n} products', {n: shown});
      }
    }

    selects.forEach(function (s) {
      s.addEventListener('change', applyFilters);
    });

    // Honour ?goal= / ?flavor= so the homepage "Shop by goal" chips and any
    // shared link land on a pre-filtered grid instead of the full collection.
    var params = new URLSearchParams(window.location.search);
    ['goal', 'flavor', 'sort'].forEach(function (name) {
      var value = params.get(name);
      if (!value) return;
      var select = document.querySelector('[data-filter="' + name + '"]');
      if (!select) return;
      var match = Array.prototype.slice.call(select.options).find(function (o) {
        return o.value.toLowerCase() === value.toLowerCase();
      });
      if (match) select.value = match.value;
    });
    applyFilters();

    document.querySelectorAll('[data-filter-clear]').forEach(function (clear) {
      clear.addEventListener('click', function (e) {
        e.preventDefault();
        selects.forEach(function (s) {
          s.value = s.getAttribute('data-filter') === 'sort' ? 'featured' : 'All';
        });
        applyFilters();
      });
    });
  }
})();

/* =========================================================================
   Discount popup
   ========================================================================= */
(function () {
  'use strict';

  /* Copy a discount code. A code the shopper cannot take is decoration, so the
     button itself confirms the copy rather than a toast that has vanished by
     the time anyone looks. Falls back to selecting the text where the
     clipboard API is refused (non-secure context, permissions). */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-copy-code]');
    if (!btn) return;
    var label = btn.querySelector('[data-copy-label]') || btn;
    var original = label.textContent;

    function done() {
      btn.classList.add('is-copied');
      label.textContent = btn.getAttribute('data-copied-label') || 'Copied';
      setTimeout(function () {
        label.textContent = original;
        btn.classList.remove('is-copied');
      }, 2000);
    }

    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(btn.getAttribute('data-copy-code')).then(done, select);
    } else {
      select();
    }

    function select() {
      try {
        var range = document.createRange();
        range.selectNodeContents(label);
        var sel = window.getSelection();
        sel.removeAllRanges();
        sel.addRange(range);
      } catch (err) {
        /* selection refused; the code is still readable on screen */
      }
      btn.setAttribute('aria-label', window.Nutritia.t('copy_code_label', 'Select the gift or discount code and copy it'));
    }
  });

  /* Uses a real <dialog> with showModal(), which gives Escape-to-close, a focus
     trap and an inert background for free — all of which a div-based modal has
     to reimplement, usually incompletely. */
  class Popup extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('[data-popup-dialog]');
      if (!this.dialog || typeof this.dialog.showModal !== 'function') return;

      this.key = 'nutritia-popup-' + (this.dataset.version || '1');
      this.bindClose();
      this.bindGoals();
      this.bindForm();

      // A successful signup re-renders the page with the form posted, so the
      // dialog reopens to show the code.
      //
      // Match on the reveal being VISIBLE, not merely present. The reveal div
      // is always in the DOM (hidden until the form posts), so testing for
      // [role="status"] alone was true on every page load — which reopened the
      // popup before dismissed() was ever consulted, and made "No thanks"
      // look broken.
      var revealed = this.querySelector('[data-popup-done]:not([hidden])');
      if (revealed) {
        this.showEmailStep();
        var body = this.querySelector('[data-popup-body]');
        if (body) body.hidden = true;
        this.open();
        this.remember();
        return;
      }

      // A rejected email (typo, blocked address) also comes back as a page
      // load. Reopen on the email step so the error is seen, not lost.
      if (this.querySelector('[data-popup-error]')) {
        this.showEmailStep();
        this.open();
        return;
      }

      if (this.dismissed()) return;
      this.arm();
    }

    dismissed() {
      try {
        var until = Number(localStorage.getItem(this.key));
        return Boolean(until) && Date.now() < until;
      } catch (e) {
        // Private browsing: better to show once than to break.
        return false;
      }
    }

    remember() {
      var days = Number(this.dataset.rememberDays || 30);
      try {
        localStorage.setItem(this.key, String(Date.now() + days * 86400000));
      } catch (e) {
        /* nothing to do; it simply shows again next visit */
      }
    }

    arm() {
      var self = this;
      var delay = Number(this.dataset.delay || 8000);
      var scroll = Number(this.dataset.scroll || 0);
      var fired = false;

      function fire() {
        if (fired) return;
        fired = true;
        window.removeEventListener('scroll', onScroll);
        clearTimeout(timer);
        self.open();
      }

      function onScroll() {
        var max = document.documentElement.scrollHeight - window.innerHeight;
        if (max > 0 && (window.scrollY / max) * 100 >= scroll) fire();
      }

      var timer = setTimeout(fire, delay);
      if (scroll > 0) window.addEventListener('scroll', onScroll, {passive: true});

      // Exit intent: pointer leaving upward toward the browser chrome. Desktop
      // only — touch has no equivalent signal, and guessing from a fast scroll
      // up misfires on ordinary browsing.
      if (this.dataset.exitIntent === 'true' && window.matchMedia('(hover: hover)').matches) {
        document.addEventListener('mouseout', function onOut(e) {
          if (e.relatedTarget || e.clientY > 8) return;
          document.removeEventListener('mouseout', onOut);
          fire();
        });
      }
    }

    open() {
      this.dialog.showModal();
      this.startCountdown();
    }

    /* The timer is urgency, not a lie: when it reaches zero it simply stops and
       hides. The offer's real expiry lives on the discount in Shopify. */
    startCountdown() {
      var el = this.querySelector('[data-popup-timer]');
      var left = Number(this.dataset.countdown || 0);
      if (!el || left <= 0) return;

      var self = this;
      function tick() {
        if (left <= 0) {
          clearInterval(self.timer);
          el.hidden = true;
          return;
        }
        var m = Math.floor(left / 60);
        var s = left % 60;
        el.textContent = m + ':' + String(s).padStart(2, '0');
        left -= 1;
      }
      tick();
      this.timer = setInterval(tick, 1000);
    }

    /* Submitting.

       This deliberately does NOT post over fetch. Shopify runs an invisible
       reCAPTCHA on customer forms and injects the token during a real submit;
       a raw fetch POST skips that and Shopify answers 400 "Missing CAPTCHA
       token", so an AJAX version would silently drop every signup. Verified
       against the live store.

       So the form submits natively and the page returns with
       form.posted_successfully?, at which point connectedCallback reopens the
       dialog straight onto the reveal. What we can remove is the ugly part:
       the "#contact_form" fragment Shopify puts on the action, which makes the
       browser jump to an anchor that does not exist on this page. */
    bindForm() {
      var form = this.querySelector('form[data-popup-form], .npop__form');
      if (!form) return;

      // Drop the anchor so the return lands at the top of the page, not at a
      // phantom #contact_form target.
      if (form.action.indexOf('#') !== -1) form.action = form.action.split('#')[0];

      form.addEventListener('submit', function () {
        var btn = form.querySelector('[type="submit"]');
        if (btn) { btn.disabled = true; btn.textContent = 'Unlocking\u2026'; }
        // Remember before we navigate, so a dismissal is not lost on the reload.
        try { sessionStorage.setItem('nutritia-popup-submitting', '1'); } catch (e) {}
      });
    }

    bindGoals() {
      var self = this;
      this.querySelectorAll('[data-popup-goal]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          // Record the answer as a customer tag so the segmentation is usable
          // in a Klaviyo flow, not just a click that disappears.
          var tags = self.querySelector('[data-popup-tags]');
          if (tags) {
            var goal = btn.getAttribute('data-popup-goal');
            tags.value = (tags.value ? tags.value + ',' : '') + 'goal-' + goal;
          }
          self.showEmailStep();
        });
      });
    }

    showEmailStep() {
      var goal = this.querySelector('[data-popup-step="goal"]');
      var email = this.querySelector('[data-popup-step="email"]');
      if (goal) goal.hidden = true;
      if (email) {
        email.hidden = false;
        var input = email.querySelector('input[type="email"]');
        if (input) setTimeout(function () { input.focus(); }, 50);
      }
    }

    bindClose() {
      var self = this;
      this.querySelectorAll('[data-popup-close]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          self.remember();
          self.dialog.close();
        });
      });

      // Clicking the backdrop closes it; clicking inside must not.
      this.dialog.addEventListener('click', function (e) {
        if (e.target !== self.dialog) return;
        self.remember();
        self.dialog.close();
      });

      // Escape fires close directly, so the dismissal still has to be recorded.
      this.dialog.addEventListener('close', function () {
        clearInterval(self.timer);
        self.remember();
      });
    }
  }

  if (!customElements.get('nutritia-popup')) {
    customElements.define('nutritia-popup', Popup);
  }
})();

/* =========================================================================
   Marquee
   -------------------------------------------------------------------------
   Clones the single rendered group until the track is at least twice the
   container width, then shifts by exactly one group width. A fixed number of
   duplicates in Liquid cannot fill an arbitrarily wide monitor — that is what
   left a visible gap on large screens.
   ========================================================================= */
(function () {
  'use strict';

  function build(root) {
    var track = root.querySelector('[data-marquee-track]');
    var group = root.querySelector('[data-marquee-group]');
    if (!track || !group) return;

    // Reset to a single group before measuring, so resize recalculates cleanly.
    track.querySelectorAll('[data-marquee-group]').forEach(function (g, i) {
      if (i > 0) g.remove();
    });
    track.classList.remove('is-running');

    var groupWidth = group.getBoundingClientRect().width;
    if (!groupWidth) return;

    var needed = Math.ceil((root.offsetWidth * 2) / groupWidth);
    for (var i = 1; i < Math.max(needed, 2); i++) {
      var clone = group.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      track.appendChild(clone);
    }

    var total = track.getBoundingClientRect().width;
    track.style.setProperty('--certs-shift', (groupWidth / total * 100) + '%');
    // Constant speed regardless of how many clones exist.
    track.style.setProperty('--certs-duration', Math.max(12, groupWidth / 40) + 's');
    track.classList.add('is-running');
  }

  var marquees = document.querySelectorAll('[data-marquee]');
  if (!marquees.length) return;
  marquees.forEach(build);

  var resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () { marquees.forEach(build); }, 200);
  });
})();
